import { Injectable } from '@angular/core';
import { AssetImage, AssetImagesProviderService } from '@web/shared/ui';

@Injectable()
export class AppAssetImagesProviderService extends AssetImagesProviderService {
  public override rootDir(): string {
    return 'assets/images';
  }

  public override images(): Map<AssetImage, string> {
    /* prettier-ignore */
    return new Map<AssetImage, string>([
      [AssetImage.AgnesRebel, 'agnes_rebel_v1.webp'],
      [AssetImage.Contact, 'contact_image.webp'],
      [AssetImage.DefaultAvatar, 'default_avatar.jpg'],
      [AssetImage.FooterBackground, 'footer_background.png'],
      [AssetImage.MasterCardAndVisa, 'mastercard_and_visa.png'],
      [AssetImage.NatWithLove, 'nat_with_love_v1.webp'],
      [AssetImage.PaymentSystem, 'payment_systems.png'],
      [AssetImage.PayU, 'payu.png'],
      [AssetImage.PayUInstallments, 'payu_installments.png'],
      [AssetImage.PayUInstallmentsBanner, 'payu_installments_banner.png'],
      [AssetImage.PureBeautyLogo, 'pure_beauty_logo.svg'],
      [AssetImage.PureBeautyLogoWhite, 'pure_beauty_logo_white.svg'],
      [AssetImage.SampleBoxCurrentlyOnSaleOne, 'samples/sample-box-currently-on-sale-one.webp'],
      [AssetImage.SampleBoxCurrentlyOnSaleTwo, 'samples/sample-box-currently-on-sale-two.webp'],
      [AssetImage.SampleBoxDetailsImage, 'samples/sample-box-details-image.webp'],
      [AssetImage.NewsletterBanner, 'newsletter_banner.webp'],
    ]);
  }
}
